<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
import employeePrivilege from "./employeePrivilege.vue";
import privilegeCoupon from "./privilegeCoupon.vue";
import writeOffVoucher from "./writeOffVoucher.vue";

let tabBox = {
  // '员工特权': {property: 'employeePrivilege'},
  '特权优惠券': {property: 'privilegeCoupon'},
  '核销代金券（线下）': {property: 'writeOffVoucher'}
}

export default {
  name: "discount",
  components: {
    employeePrivilege,
    privilegeCoupon,
    writeOffVoucher
  },
  data() {
    return {
      meaulistTab: this.meaulist.meaulistGet(this, tabBox),
      activeName:''
    };
  },
  created() {
    this.inittab();
  },
  methods: {
    inittab() {
      this.activeName =
        this.$route.query.tab !== undefined
          ? this.$route.query.tab
          : "privilegeCoupon";
    },
    tabCurrentFn(index){
      console.log(index)
      this.meaulistTab.firstTab = index
    }
  }
};
</script>
